
<template>
        <div class="row justify-content-center">
            <div class="col-lg-5 col-md-7" style="margin-top:0px;">
                <div class="card bg-secondary shadow border-0">


<!--                     <div class="card-header bg-transparent pb-5">
                        <div class="text-muted text-center mt-2 mb-3"><small>Sign in with</small></div>
                        <div class="btn-wrapper text-center">
                            <a href="#" class="btn btn-neutral btn-icon">
                                <span class="btn-inner--icon"><img src="img/icons/common/github.svg"></span>
                                <span class="btn-inner--text">Github</span>
                            </a>
                            <a href="#" class="btn btn-neutral btn-icon">
                                <span class="btn-inner--icon"><img src="img/icons/common/google.svg"></span>
                                <span class="btn-inner--text">Google</span>
                            </a>
                        </div>
                    </div> -->

                    <div class="card-body px-lg-5 md-lg-5" :dir="language">
                        <div class="text-center mb-3">
                            <h3>{{texts.login}}</h3>
                        </div>
                         <!-- <div class="text-center mb-4">
                            <medium v-if="errors" style="color: red;">{{errors}}</medium>
                        </div> -->
                        <div class="text-center mb-4">
                            <medium v-if="localerrors" style="color: red;">{{localerrors}}</medium>
                        </div>
                          <form v-on:submit.prevent="onSubmit(email, password);">
                            <fieldset class="form-group">
                            <input addon-left-icon="ni ni-email-83"
                                        :placeholder="texts.email"
                                        type="email"
                                        v-model="email"

                                        v-bind:class="{ 'form-control':true, 'is-invalid' : !validEmail(email)&& emailBlured}"
                                         v-on:blur="emailBlured = true"
                                        >
                            </input>
                        </fieldset>
<fieldset class="form-group">
                            <input class="form-control"
                                        :placeholder="texts.password"
                                        type="password"

                                        v-model="password">
                            </input>
                        </fieldset>

                            <!-- <base-checkbox class="custom-control-alternative">
                                <span class="text-muted">Remember me</span>
                            </base-checkbox> -->
                            <div class="text-center">
                                <button v-if="!isLoading || errors" type="primary"  class="btn btn-primary my-3 px-lg-8">{{texts.login}}</button>
                                <button v-if="isLoading" type="primary" style="width : 350px" class="btn btn-primary my-3 px-lg-8">Loading..</button>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="row mt-3" :dir="language">
                    <div class="col-6" v-if="language=='ltr'" >
                        <a href="#/forgotpass" class="text-light">
                            <large>{{texts.forgotpass}}</large>
                        </a>
                    </div>
                    <div class="col-6" v-else style="text-align : right;" >
                        <a href="#/forgotpass" class="text-light">
                            <large>{{texts.forgotpass}}</large>
                        </a>
                    </div>
                    <div class="col-6" v-if="language=='ltr'" style="text-align : right;">
                      <a v-on:click="switchLang()" >
                          <span style="color:#fff">&nbsp;&nbsp;{{texts.lang}}</span>
                          <i class="ni ni-world-2" style="color:#fff; margin-left : 10px;"></i>
                      </a>
                    </div>
                    <div class="col-6" v-else style="text-align:left;">
                      <a  v-on:click="switchLang()">
                          <span style="color:#fff">&nbsp;&nbsp;{{texts.lang}}</span>
                          <i class="ni ni-world-2" style="color:#fff; margin-right : 10px;"></i>
                      </a>
                    </div>

                </div>
                <modal :show.sync="modals.modal0">
                 <template slot="header">
                    <span style="font-size: 24px; color: black;" id="exampleModalLabel">Language Preference</span>
                 </template>
                 <div>
                   <center>
                     <base-button class="btn-lg" block type="primary" @click="setLanguagePreference('ltr')" style="width : 350 px;">English</base-button>
                    <base-button class="btn-lg"  block type="primary" @click="setLanguagePreference('rtl')" style="width : 350 px;">العربية</base-button>
                     </center>

                 </div>
                 <template slot="footer">



                 </template>
                </modal>
                <!-- <div class="row mt-3">
                    <div class="col-6">
                        <a href="#" class="text-light"><small>Forgot password?</small></a>
                    </div>
                    <div class="col-6 text-right">
                        <router-link to="/register" class="text-light"><small>Create new account</small></router-link>
                    </div>
                </div> -->
            </div>
        </div>
</template>
<script>
import { mapState } from "vuex";
import { LOGIN, LOGOUT, LANGUAGE, ONBOARDING } from "@/store/actions.type";
  import store from "@/store";
  import UserService from "@/common/user.service";

  export default {
    name: 'login',
    data() {
      return {
        texts : {
          login : UserService.getLanguage() === "rtl" ? "تسجيل الدخول" : "Login",
          email : UserService.getLanguage() === "rtl" ? "البريد الإلكتروني" : "Email",
          password : UserService.getLanguage() === "rtl" ? "كلمة السر" : "Password",
          forgotpass : UserService.getLanguage() === "rtl" ? "هل نسيت كلمة السر؟" : "Forgot Password?",
          lang : UserService.getLanguage() === "rtl" ? "English" : "العربية" ,
        },
        language : UserService.getLanguage() || "ltr",
        modals : {
          modal0 : false
        },
        email: '',
        password: '',
        isLoading: false,
        localerrors : null,
        emailBlured : false,
            valid : false

      }
    },
    methods: {
      switchLang() {

          if (UserService.getLanguage() === "ltr") {
            Promise.all([
              store.dispatch(LANGUAGE, "rtl"),

            ]).then(() => {
              location.reload();
            });
          }
          else {
            Promise.all([
              store.dispatch(LANGUAGE, "ltr"),

            ]).then(() => {
              location.reload();
            });
          }



      },
      setOnBoarding(lang) {
        // this.modals.modal0 = false;
        console.log("SETTING LANGUAGE : " + lang);
        Promise.all([
          store.dispatch(ONBOARDING, lang),

        ]).then(() => {
          // location.reload();
        });
      },
      setLanguagePreference(lang) {
        this.modals.modal0 = false;
        console.log("SETTING LANGUAGE : " + lang);
        Promise.all([
          store.dispatch(LANGUAGE, lang),

        ]).then(() => {
          location.reload();
        });
      },
        validate : function(){
          this.emailBlured = true;
           if( this.validEmail(this.email)){
              this.valid = true;
           }
        },
        validEmail : function(email) {
            if (email !== '') {
                var re = /(.+)@(.+){2,}\.(.+){2,}/;
                return re.test(email.toLowerCase());
            }
            else {
                return true;
            }

        },
        onSubmit(email, password) {
            if (email !== '' && password !== '') {
                this.localerrors = null;

                email = email.trim();
                password = password.trim();

                Promise.all([
                  store.dispatch(LOGIN, { email, password }),

                ]).then((data) => {
                  console.log("DATA");
                  console.log(data);
                  // data = [data];
                  console.log("ERRFLAG " + data[0]['errFlag']);
                  if (Number(data[0]['errFlag']) === 0) {
                    sessionStorage.setItem('reloaded', 'yes');

                    // if (Number(data[0]['data'].registration) === 1) {
                    //   this.isLoading = false;
                    //   this.$router.push({ name: "registration" })
                    // }
                    // else {

                      this.isLoading = false;
                    if (data[0]['data']) {
                      console.log("HERE 1");
                      if (Number(data[0]['data'].registration) === 1) {
                      this.isLoading = false;
                      this.$router.push({ name: "registration" })
                      }
                      else if (data[0]['data']['reset']) {
                        if (Number(data[0]['data']['reset']) === 1) {
                          this.$router.push({ name: "resetpass" });
                        }
                      }
                    }
                    else {
                      console.log("HERE 2");
                      if (data[0]['assignments'].length > 1) {
                        this.$router.push({ name: "assignments" });
                      }
                      //
                      else if (data[0]['assignments'].length === 0) {
                        console.log("HERE 3");
                        this.$router.push({ name: "assignments" });
                      }
                      //
                      else {
                        console.log("PUSHING ROUTER TO OVERVIEW");
                        this.$router.push({ name: "overview" });
                      }
                    // }
                      // this.$router.push({ name: "validateotp" })
                    }

                  }
                  else {
                    if (this.language === "ltr") {
                      this.localerrors = "Wrong email or password";
                    }
                    else {
                      this.localerrors ="البريد الالكتروني او كلمة المرور خاطئة";
                    }
                  }
                });
            }
            else {
              if (this.language === "ltr") {
                this.localerrors = "Email or Password cannot be empty !"
              }
              else {
                this.localerrors = "لا يمكن أن يكون البريد الإلكتروني أو كلمة المرور فارغين!";
              }


            }

          // this.$store
          //   .dispatch(LOGIN, { email, password })
          //   .then(() => this.$router.push({ name: "dashboard" }));
        }
    },
      computed: {

        ...mapState({
          errors: state => state.auth.errors
        })
      },
      mounted() {
        // console.log("USER LANGAUGE : " + UserService.getLanguage());
        if (UserService.getLanguage()) {
          if (UserService.getLanguage() === "" || UserService.getLanguage() == undefined){
            this.setOnBoarding("1");
            // UserService.saveOnOboarding("1");
            this.modals.modal0 = true;
          }
        }
        else {
          this.setOnBoarding("1");
          this.modals.modal0 = true;
        }

         Promise.all([
                  store.dispatch(LOGOUT)

                ]).then(() => {

                });
      }
  };
</script>
<style>
</style>
